import moment from 'moment';
import { transformComplianceData } from 'components/Molecules/Upload/QMASDocument/helper';
import { AutoMapper } from './AutoMapper';
import { getDateWithFormat } from 'util/date';
import { DATE_FORMAT_02 } from 'shared/constants';

const mapper = AutoMapper.getInstance();

// #region FROM API TO VIEW
mapper
  .createMap('API_ComplianceTestData', 'View_ComplianceTestData')
  .forMember('id', (source) => {
    return source.id;
  })
  .forMember('result', (source) => source.result)
  .forMember('countryListId', (source) => {
    if (source.countryList) {
      return {
        value: source.countryList.id,
        label: source.countryList.name,
        ...source.countryList,
      };
    }
    return null;
  })
  .forMember('serviceProviderId', (source) => {
    if (source.serviceProvider) {
      return {
        value: source.serviceProvider.id,
        label: source.serviceProvider.fullname || source.serviceProvider.name,
        data: source.serviceProvider,
      };
    }
    return null;
  })
  .forMember('testItemId', (source) => {
    if (source.testItem) {
      return {
        value: source.testItem.id,
        label: `${source.testItem.name}, ${source.citation?.name || ''}`,
        data: {
          ...source.testItem,
          citationList: source.citation,
          citationListId: source.citation?.id,
        },
      };
    }
    return null;
  })
  .forMember('citationId', (source) => {
    if (source.citation) {
      return source.citation;
    }
    return null;
  })
  .forMember('reportId', (source) => source.reportId)
  .forMember('expiryDate', (source) => (source.expiryDate ? moment(source.expiryDate) : undefined))
  .forMember('testDate', (source) => (source.testDate ? moment(source.testDate) : undefined));

mapper
  .createMap('API_ComplianceCertificateData', 'View_ComplianceCertificateData')
  .forMember('id', (source) => source.id)
  .forMember('certificateTypeId', (source) => {
    if (source.certificateType) {
      return {
        value: source.certificateType.id,
        label: source.certificateType.name,
        data: source.certificateType,
      };
    }
    return null;
  })
  .forMember('customCertificateScoreId', (source) => {
    if (source.customCertificateScore) {
      return {
        value: source.customCertificateScore.id,
        label: source.customCertificateScore.name,
        data: source.customCertificateScore,
      };
    }
    return null;
  })
  .forMember('customIssuePartyId', (source) => {
    if (source.customIssueParty) {
      return {
        value: source.customIssueParty.id,
        label: source.customIssueParty.name,
        data: source.customIssueParty,
      };
    }
    return null;
  })
  .forMember('expiryDate', (source) => (source.expiryDate ? moment(source.expiryDate) : undefined))
  .forMember('testDate', (source) => (source.testDate ? moment(source.testDate) : undefined));

mapper
  .createMap('API_ComplianceOtherData', 'View_ComplianceOtherData')
  .forMember('id', (source) => source.id)
  .forMember('customComplianceOtherDataTypeId', (source) => {
    if (source.customComplianceOtherDataType) {
      return {
        value: source.customComplianceOtherDataType.id,
        label: source.customComplianceOtherDataType.name,
        data: source.customComplianceOtherDataType,
      };
    }
    return null;
  })
  .forMember('name', (source) => source.name)
  .forMember('description', (source) => source.description)
  .forMember('customIssuePartyId', (source) => {
    if (source.customIssueParty) {
      return {
        value: source.customIssueParty.id,
        label: source.customIssueParty.name,
        data: source.customIssueParty,
      };
    }
    return null;
  })
  .forMember('result', (source) => source.result)
  .forMember('expiryDate', (source) => (source.expiryDate ? moment(source.expiryDate) : undefined))
  .forMember('testDate', (source) => (source.testDate ? moment(source.testDate) : undefined));
// #endregion

export const ComplianceMappings = {
  /**
   * map source from API to View.
   */
  mapTestDataToView: (source) => {
    return mapper.map(source, 'API_ComplianceTestData', 'View_ComplianceTestData');
  },
  mapCertificateDataToView: (source) => {
    return mapper.map(source, 'API_ComplianceCertificateData', 'View_ComplianceCertificateData');
  },
  mapOtherDataToView: (source) => {
    return mapper.map(source, 'API_ComplianceOtherData', 'View_ComplianceOtherData');
  },
  mapComplianceDataToMutate: (source) => {
    // Re-use the Transform Compliance Data from QMASUploadDocument
    return transformComplianceData(source);
  },
  transformReminder: (source) => {
    return {
      issueDate: source.issueDate ? source.issueDate.format(DATE_FORMAT_02) : null,
      expiryDate: source.expiryDate ? source.expiryDate.format(DATE_FORMAT_02) : null,
      reminderDate: source.reminderDate ? source.reminderDate.format(DATE_FORMAT_02) : null,
      reviewDate: source.reviewDate ? source.reviewDate.format(DATE_FORMAT_02) : null,
      reminderType: source.reminderType,
      reminderNote: source.note,
    };
  },
};
